import { normalizeQuestionOptionsOrder } from "./normalize-question-options-order";

const updateQuestionResponse = ({ questionId, status, point, totalPoint }) => {
    const { __, sprintf } = window.wp?.i18n || {};
    if (!__) return;

    const tryUpdate = () => {
        const input =
            document.querySelector(`input[name="learn-press-question-${questionId}"]`) ||
            document.querySelector(`input[name="learn-press-question-${questionId}[]"]`);

        const questionWrap = input?.closest('.question') ||
            document.querySelector(`.question[data-id="${questionId}"]`) ||
            document.querySelector(`#learn-press-question-${questionId}`);

        const responseNode = questionWrap?.querySelector('.question-response');
        const labelNode = responseNode?.querySelector('.label');
        const pointNode = responseNode?.querySelector('.point');

        if (!responseNode || !labelNode || !pointNode) {
            return false;
        }

        const label =
            status === 'partial'
                ? __('Частково вірно', 'learnpress')
                : status === 'correct'
                    ? __('Correct', 'learnpress')
                    : __('Incorrect', 'learnpress');

        responseNode.className = `question-response ${status}`;
        labelNode.textContent = label;
        pointNode.textContent = sprintf(__('%d/%d point', 'learnpress'), point, totalPoint);

        return true;
    };

    if (tryUpdate()) {
        return;
    }

    let attempts = 0;
    const observer = new MutationObserver(() => {
        attempts += 1;
        if (tryUpdate() || attempts > 40) {
            observer.disconnect();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
};

const getQuizId = () => {
    return (
        window?.LP_QUIZ_SETTINGS?.ID ||
        window?.LP_QUIZ_SETTINGS?.id ||
        window?.LP_QUIZ_SETTINGS?.quiz_id ||
        null
    );
};

const getQuizStorage = (quizId) => {
    if (!quizId) return null;
    const key = `LP_Quiz_${quizId}_Rozetka`;
    try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
    } catch (_e) {
        return null;
    }
};

const saveQuizStorage = (quizId, data) => {
    if (!quizId) return;
    const key = `LP_Quiz_${quizId}_Rozetka`;
    localStorage.setItem(key, JSON.stringify(data || {}));
};

const applyStoredQuestionStatuses = (quizId) => {
    const storage = getQuizStorage(quizId);
    const statuses = storage?.rozetka_partial;
    if (!statuses || typeof statuses !== 'object') {
        return false;
    }

    let applied = false;
    Object.entries(statuses).forEach(([questionId, payload]) => {
        const normalized =
            typeof payload === 'string'
                ? { status: payload }
                : payload || {};

        if (!normalized.status) {
            return;
        }

        const questionMeta = Array.isArray(window?.LP_QUIZ_SETTINGS?.questions)
            ? window.LP_QUIZ_SETTINGS.questions.find((q) => String(q.id) === String(questionId))
            : null;

        const point = normalized.point ?? questionMeta?.point ?? 0;
        const totalPoint = normalized.totalPoint ?? questionMeta?.point ?? 0;

        updateQuestionResponse({
            questionId,
            status: normalized.status,
            point,
            totalPoint,
        });
        applied = true;
    });

    return applied;
};

const waitAndApplyStoredStatuses = (quizId) => {
    let attempts = 0;
    const tryApply = () => {
        attempts += 1;
        if (applyStoredQuestionStatuses(quizId) || attempts > 20) {
            observer?.disconnect();
            return;
        }
    };

    const observer = new MutationObserver(() => tryApply());
    observer.observe(document.body, { childList: true, subtree: true });
    tryApply();
};

const initPartialRestHook = (deps = {}) => {
    const apiFetch = window.wp?.apiFetch;
    if (!apiFetch || typeof apiFetch.use !== 'function') {
        return;
    }

    apiFetch.use((options, next) => {
        const isCheckAnswer = (() => {
            if (typeof options.path === 'string') {
                return options.path.includes('lp/v1/users/check-answer');
            }
            if (typeof options.url === 'string') {
                return options.url.includes('lp/v1/users/check-answer');
            }
            return false;
        })();

        return next(options).then((res) => {
            try {
                if (isCheckAnswer) {
                    const questionId = res?.question_id;
                    const questionOptions = res?.options;
                    const fromPayload = res?.rozetka_partial;
                    const quizId = fromPayload?.quiz_id;

                    if (questionId) {

                        if (fromPayload) {
                            updateQuestionResponse({
                                questionId,
                                status: fromPayload.status,
                                point: fromPayload.point ?? 0,
                                totalPoint: fromPayload.total_point ?? 0,
                            });
                        }

                        if (quizId) {
                            const quizStorage = getQuizStorage(quizId) || {};
                            const rozetkaPartial = quizStorage.rozetka_partial || {};

                            rozetkaPartial[questionId] = {
                                status: fromPayload.status,
                                point: fromPayload.point ?? 0,
                                totalPoint: fromPayload.total_point ?? 0,
                            };

                            quizStorage.rozetka_partial = rozetkaPartial;
                            saveQuizStorage(quizId, quizStorage);

                            waitAndApplyStoredStatuses(quizId);
                        }

                        setTimeout(() => normalizeQuestionOptionsOrder(questionId, questionOptions), 100);
                    }
                }
            } catch (_e) {
                // noop
            }
            return res;
        });
    });

    const existingQuizId = getQuizId();
    if (existingQuizId) {
        waitAndApplyStoredStatuses(existingQuizId);
    }
};

export default initPartialRestHook;
